module.exports = __webpack_public_path__ + "img/4631.df56087c.jpg";